<template>
  <div v-if="isActive" class="tc-dnd-item-container" :style="{'left':posX+'px','top':posY+'px'}">
      <img  class="tc-dnd-item-image" alt="dragItemImg" :src="getImage()">
  </div>
</template>

<script>

import { useStoreUI } from '@/Store/storeUI';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { getImage } from '@/libs/getImage';
import { caseComponentsLib } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { isCursorOutsideToolChest } from '@/Engine/eventHandlers/libs/isModelOutsideToolChest';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';

export default {
  name: 'DraggedItem',
  setup() {
    const storeCaseConfiguration = useStoreCaseConfiguration();
    const storeUI = useStoreUI();
    const storeItemsFromApi = useStoreItemsFromApi();
    return {
      storeCaseConfiguration,
      storeUI,
        storeItemsFromApi,
    };
  },
  data(){
    return {
      isCursorOutsideToolChest:false,
    };
  },
  computed: {
    isActive() {
      return !!this.storeUI.dndItem&&this.storeUI.isCursorOutsideToolChest;
    },
    posX(){
      return this.storeUI.pointerPosition.x;
    },
    posY(){
      return this.storeUI.pointerPosition.y;
    },
  },
  methods:{
    getImage(){
      const item=caseComponentsLib.find(component => component.id === this.storeUI.dndItem);
      // console.log('item fullData',item);
      if(!item)return;
      return item.image.length?item.image:getImage(
          this.storeItemsFromApi.getApiItemByXmlId(item.xmlId)?.previewPicture);
    },
  },
  // props: [ 'x', 'y', 'image', 'isActive' ],
};
</script>


<style scoped lang="scss">
.tc-dnd-item-container{
  position:absolute;
  z-index: 100;
  width: 120px;
  max-height: 65px;
}
.tc-dnd-item-image{
  width: 100%;
  height: 100%;
}
</style>
